import React, { useEffect, useState } from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableRow, TableHead, CircularProgress, Alert } from '@mui/material';
import { getStudentDashboardData, StudentDashboardData } from '../services/studentDashboardService';

const AdmitCards: React.FC = () => {
  const [dashboardData, setDashboardData] = useState<StudentDashboardData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const data = await getStudentDashboardData();
        setDashboardData(data);
      } catch (err) {
        setError('Failed to load admit card data. Please try again later.');
      } finally {
        setLoading(false);
      }
    };
    fetchDashboardData();
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box maxWidth="lg" sx={{ mt: 4 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  if (!dashboardData) {
    return null;
  }

  const admit = dashboardData.admitCard;

  return (
    <Box sx={{ bgcolor: '#f7fbe6', minHeight: '100vh', p: 2 }}>
      {/* Admit Card Main Box */}
      <Box sx={{ border: '2px solid #222', borderRadius: 2, bgcolor: '#f5fbe6', maxWidth: 900, mx: 'auto', p: 2 }}>
        <Typography align="center" fontWeight="bold" sx={{ fontSize: 18, mb: 1 }}>
          PRI BOARD EXAMINATION &nbsp; ADMIT CARD
        </Typography>
        <Typography align="center" fontWeight="bold" sx={{ fontSize: 20, mb: 1 }}>
          YEAR:- <span style={{ fontWeight: 400 }}>2023-2024</span>
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 1 }}>
          <Typography fontWeight="bold">ROLL NO:- <span style={{ fontWeight: 400, background: '#fff', padding: '0 8px' }}>{admit.rollNumber}</span></Typography>
          <Typography fontWeight="bold">CLASS:- <span style={{ fontWeight: 400 }}>{admit.class} {admit.section}</span></Typography>
        </Box>

        {/* Student Info Table */}
        <Table sx={{ mb: 1 }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ bgcolor: '#6ec6e6', fontWeight: 'bold', border: '1px solid #222', textAlign: 'center' }}>STUDENT NAME</TableCell>
              <TableCell sx={{ bgcolor: '#6ec6e6', fontWeight: 'bold', border: '1px solid #222', textAlign: 'center' }}>EXAM NAME</TableCell>
              <TableCell sx={{ bgcolor: '#6ec6e6', fontWeight: 'bold', border: '1px solid #222', textAlign: 'center' }}>EXAM DATE</TableCell>
              <TableCell sx={{ bgcolor: '#6ec6e6', fontWeight: 'bold', border: '1px solid #222', textAlign: 'center' }}>EXAM CENTER</TableCell>
              <TableCell sx={{ bgcolor: '#6ec6e6', fontWeight: 'bold', border: '1px solid #222', textAlign: 'center' }}>EXAM TIME</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell sx={{ border: '1px solid #222', textAlign: 'center' }}>{admit.name}</TableCell>
              <TableCell sx={{ border: '1px solid #222', textAlign: 'center' }}>{admit.examName}</TableCell>
              <TableCell sx={{ border: '1px solid #222', textAlign: 'center' }}>{admit.examDate}</TableCell>
              <TableCell sx={{ border: '1px solid #222', textAlign: 'center' }}>{admit.examCenter}</TableCell>
              <TableCell sx={{ border: '1px solid #222', textAlign: 'center' }}>{admit.examTime}</TableCell>
            </TableRow>
          </TableBody>
        </Table>

        {/* Photo and Signature */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
          <Box sx={{ textAlign: 'center', flex: 1 }}>
            <Box
              sx={{
                width: '120px',
                height: '150px',
                border: '1px solid #000',
                margin: '0 auto',
                mb: 1,
                background: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {admit.photo ? (
                <img src={admit.photo} alt="Student" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              ) : (
                <Typography>Photo</Typography>
              )}
            </Box>
            <Typography variant="body2">Student's Photo</Typography>
          </Box>
          <Box sx={{ textAlign: 'center', flex: 1 }}>
            <Box
              sx={{
                width: '120px',
                height: '50px',
                border: '1px solid #000',
                margin: '0 auto',
                mb: 1,
                background: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {admit.signature ? (
                <img src={admit.signature} alt="Signature" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
              ) : (
                <Typography>Signature</Typography>
              )}
            </Box>
            <Typography variant="body2">Student's Signature</Typography>
          </Box>
        </Box>

        {/* Principal and Footer */}
        <Box sx={{ bgcolor: '#d6eaf8', mt: 2, p: 2, borderRadius: 1, textAlign: 'center' }}>
          <Typography fontWeight="bold" sx={{ fontSize: 16, mb: 1 }}>PRINCIPAL</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default AdmitCards; 